import RestClient from '../../../../api/axiosInterceptor';
import { hospitalRegisterActions } from '../../../actions/user/hospital/Account/registration';
import { toast } from 'react-toastify';

/**
 * Helper function to create asynchronous actions for Redux.
 * @param {string} actionType - The action type to dispatch.
 * @param {function} apiCall - The API call function to make the request.
 */
const createAsyncAction = (actionType, apiCall) => async (dispatch) => {
  try {
    dispatch({ type: actionType.REQUEST });

    // Make the API call and wait for the response
    const response = await apiCall();

    dispatch({
      type: actionType.SUCCESS,
      payload: response.data
    });
    toast.success(response.data.message, { position: 'top-center' });
  } catch (error) {
    const errorMessage =
         error.response && error.response.data && error.response.data.error
           ? error.response.data.error
           : error.message;

    dispatch({
      type: actionType.FAILURE,
      error: error.response ? error.response.data : error.message
    });
    toast.error(errorMessage, { position: 'top-center' });
  }
};

export const registerHospital = (formData) =>
  createAsyncAction(
    hospitalRegisterActions.REGISTER_HOSPITAL,
    async () => {
      try {
        const response = await RestClient.post('hospital/hospital-registration', JSON.stringify(formData), {
          headers: {
            'Content-Type': 'application/json' // Set the content type to application/json
          }
        });
        console.log(formData);
        return response.data; // Assuming the response contains the data you need
      } catch (error) {
        throw error; // Rethrow the error to be handled by the async action
      }
    }
  );
